/** Player-facing combat text. */
export const combat = {
  "combat.exchange": "Обмен ударами…",
  "combat.arts": "Приёмы и молитва",
  "combat.artsReady": "Готово: {n}",
  "combat.loading": "Герои выходят на ристалище…",
  "combat.screen.arena": "Ристалище",
  "combat.screen.advice": "Совет писца",
  "combat.screen.instruction": "Наставление",
  "combat.screen.fight": "Поединок",
  "combat.screen.result": "Итог",
  "combat.screen.charter": "Грамота вызова",
  "combat.screen.tournament": "Турнир св. Мурлыки",
  "combat.screen.ladder": "Лествица",
  "combat.screen.balance": "Баланс",
  "combat.kicker": "ГЛАВА II · ЧЕСТЬ И СИНЯКИ",
  "combat.lead": "За честь, славу и последнюю селёдку.",
  "combat.choose": "Выберите соперника",
  "combat.resume": "Продолжить поединок",
  "combat.duel": "Вызвать на бой",
  "combat.back": "На ристалище",
  "combat.home": "Вернуться в житие",
  "combat.rules": "Как сражаться",
  "combat.record": "Победы {wins} · поражения {losses}",
  "combat.rank": "Ступень {n} / 12",
  "combat.rankHint": "Каждая победа поднимает вас на одну ступень. Поражение не отнимает славу.",
  "combat.noHistory": "Писец заточил перо. История ждёт первого поединка.",
  "combat.history": "Последние поединки",
  "combat.foe.novice": "Заяц Гуго Недобрый",
  "combat.foe.knight": "Сэр Мур из Буфета",
  "combat.foe.prior": "Приор Косой",
  "combat.foe.collector": "Лис Недоимка",
  "combat.flavor.novice": "Вызывает каждую морковь на поединок.",
  "combat.flavor.knight": "Стойка крепка. Сырные убеждения — не очень.",
  "combat.flavor.prior": "Благословляет левой. Хитрит обеими.",
  "combat.flavor.collector": "Обложил налогом вашу тень. За хвост — отдельно.",
  "combat.difficulty.novice": "Разминка",
  "combat.difficulty.knight": "Ровня",
  "combat.difficulty.prior": "Грозный",
  "combat.difficulty.collector": "Дорогая сделка",
  "combat.reward": "Награда ×{n}",
  "combat.habit": "Повадка: {action}",
  "combat.mechanic.novice": "Каждый третий ход — лихой наскок. Защита останавливает его: следующий ход без ответа, ваш урон +25%.",
  "combat.mechanic.knight": "Две застёжки кольчуги блокируют по 4 урона. Финт или Раскол земли навсегда снимает одну; суперприём обходит обе.",
  "combat.mechanic.prior": "Предупреждает об обряде за ход. Удар за 2 силы или особый приём сорвёт его. Иначе приор лечит 18 здоровья вместо атаки.",
  "combat.mechanic.collector": "Каждый третий ход: Удар и пошлина до 24 пыла. Защита бережёт здоровье; Финт — пыл, но ударит больнее. Успейте потратить пыл до взыскания.",
  "combat.phase.audit": "ПОШЛИНА ЧЕРЕЗ ХОД · Рассчитайте пыл. Сейчас: {action}.",
  "combat.phase.levy": "ПОШЛИНА · Удар; заберёт до 24 пыла. Защита: меньше урона, платите. Финт: больнее, пыл цел.",
  "combat.levyDetails": "Как работает пошлина",
  "combat.levyRule": "После трат и накопления он забирает до 24 пыла, даже сквозь Защиту. Финт уводит печать, но не Удар. Коронный приём или Буря печатей срывают пошлину. Долгов нет, золото не трогает; если кто-то пал — взыскания нет.",
  "combat.event.fervorTaken": "Проштамповано! Пыл −{n}.",
  "combat.event.levyEvaded": "Печать мимо. Пыл остался при вас.",
  "combat.event.levySuppressed": "Пошлина сорвана. Пыл не взыскан.",
  "combat.phase.rush": "ЛИХОЙ НАСКОК · Защита остановит Гуго и заставит споткнуться на следующий ход.",
  "combat.phase.stumbled": "СПОТКНУЛСЯ · Гуго не отвечает в этот ход. Ваш урон +25%.",
  "combat.event.rushStopped": "Наскок остановлен! Следующий ход Гуго пропускает.",
  "combat.phase.mail": "КОЛЬЧУГА {n}/2 · Блокирует {block} урона. Финт снимает застёжку. Далее: {action}.",
  "combat.phase.unfastened": "КОЛЬЧУГА РАССТЁГНУТА · Урон больше не снижен. Далее: {action}.",
  "combat.event.armourBroken": "Застёжка снята! Осталось {n}/2.",
  "combat.event.armourBlocked": "Кольчуга поглотила {n} урона.",
  "combat.phase.prepare": "ОБРЯД ЧЕРЕЗ ХОД · Сберегите 2 силы, чтобы прервать. Сейчас: {action}.",
  "combat.phase.chant": "ОБРЯД ИСЦЕЛЕНИЯ · Удар или особый приём прервёт его. Иначе: +18 здоровья сопернику, без атаки.",
  "combat.event.interrupted": "Обряд прерван! Без лечения и ответного удара.",
  "combat.event.foeHealed": "Приор исцеляет +{n}.",
  "combat.round": "Ход {n}",
  "combat.you": "Ваш герой",
  "combat.health": "Здоровье",
  "combat.intent": "Соперник готовит: {action}",
  "combat.heavy": "ГРОЗНЫЙ УДАР · держите защиту",
  "combat.stamina": "Силы {n}/{max}",
  "combat.fervor": "Пыл {n}/100",
  "combat.combo": "Серия ответов ×{n}",
  "combat.action.strike": "Удар",
  "combat.action.guard": "Защита",
  "combat.action.feint": "Финт",
  "combat.action.prayer": "Молитва",
  "combat.action.signature": "Коронный приём",
  "combat.action.starfall": "Звездопад",
  "combat.action.thousandCuts": "Тысяча порезов",
  "combat.action.solarCleave": "Солнечный раскол",
  "combat.action.seismicSlam": "Раскол земли",
  "combat.action.tempest": "Буря печатей",
  "combat.action.shadowDance": "Танец теней",
  "combat.cost.technique": "{fervor} пыла · силы: {stamina}",
  "combat.nextDuelTechnique": "Новые приёмы этого оружия будут доступны в следующей дуэли.",
  "combat.presentation.reply": "Ответ соперника",
  "combat.presentation.block": "Защитные печати",
  "combat.presentation.shield": "Щит принимает удар",
  "combat.cost.fervor": "{fervor} пыла",
  "combat.hint.solarCleave": "Ловит финт · сохраняет серию",
  "combat.hint.seismicSlam": "Ломает застёжку · враг может ответить",
  "combat.hint.tempest": "Блокирует ответ · +1 сила",
  "combat.hint.shadowDance": "Сохраняет серию · +2 силы",
  "combat.hint.starfall": "Взлёт → звезда → метеор · 70 пыла",
  "combat.hint.thousandCuts": "Рывок → 28 порезов → щелчок · 70 пыла",
  "combat.event.shieldBlocked": "Экипировка поглотила {n}.",
  "combat.event.techniqueBlocked": "Печати поглотили {n} урона.",
  "combat.event.staminaRestored": "Восстановлено сил: {n}.",
  "combat.hint.strike": "Бьёт финт · −2 силы",
  "combat.hint.guard": "Ловит удар · +2 силы",
  "combat.hint.feint": "Обходит защиту · −1 сила",
  "combat.hint.prayer": "Лечит {heal} HP · 40 пыла · раз за бой",
  "combat.hint.signature": "Двойной удар · 70 пыла",
  "combat.wait": "Выберите ответ. Время на вашей стороне.",
  "combat.counter": "Ловкий ответ!",
  "combat.hit": "Нанесено {dealt} · получено {received}",
  "combat.heal": "Исцеление +{n}",
  "combat.win": "Славная победа!",
  "combat.loss": "Чернила ещё не высохли",
  "combat.winSub": "Писец уже приписал вам пару сантиметров роста.",
  "combat.lossSub": "Сегодня помяли гордость. Опыт и золото всё равно ваши.",
  "combat.stats": "Ходов: {rounds} · ловких ответов: {counters}",
  "combat.paid": "Опыт и золото отправлены в житие.",
  "combat.again": "Ещё один поединок",
  "combat.upgrade": "Улучшить героя",
  "combat.rule1": "Читайте намерение соперника: защита ловит удар, удар бьёт финт, финт обходит защиту.",
  "combat.rule2": "Силы нужны для атак. Защита возвращает 2 силы, даже если ваш ответ неидеален.",
  "combat.rule3": "Ловкие ответы копят пыл и усиливают серию. Лечение стоит 40 пыла, приём оружия — 45–55, коронный приём без ответа врага — 70. Приёмы тратят пыл и не создают его.",
  "combat.rule4": "Никакой спешки: бой ждёт решения. Клавиши 1–3 — обычные действия, 4 — лечение; 5–6 — показанные приёмы оружия слева направо.",
  "combat.rule5": "Тренировки в житии помогают в бою: мощь усиливает удары, стойкость даёт здоровье, хитрость снижает урон.",
  "combat.noDuel": "Сначала выберите соперника на ристалище.",
  "combat.joke.0": "Писец записал: «Всё по плану». План не приложен.",
  "combat.joke.1": "С трибуны требуют вернуть селёдку.",
  "combat.joke.2": "Доспех звенит убедительнее аргументов.",
  "combat.joke.3": "Святой Мурлыка делает вид, что не смотрит.",
  "combat.joke.4": "Судья проглотил свисток. Бой продолжается.",
  "combat.joke.5": "Красивый удар. Почти каллиграфия."
} as const;
